const AUTH_TOKEN_KEY = "auth_token";
const GAME_KEY = process.env.REACT_APP_GAME_NAME;
const GAMEPLAY_ID = "gameplay_id";
const LEVEL_DATA_KEY = "level_data";
const GAME_DETAILS_KEY = "game_details";

const LS_KEY = {
    user_data: 'unberry_user_data',
    game_data: 'unberry_game_data'
};

const setItem = (key, data) => localStorage.setItem(key, JSON.stringify(data));
const getItem = (key) => JSON.parse(localStorage.getItem(key));

const set = {
    userData: data => {
        localStorage.setItem(
            LS_KEY.user_data,
            JSON.stringify({
                user_data: data
            })
        );
    },
    gameData: data => {
        localStorage.setItem(
            LS_KEY.game_data,
            JSON.stringify({
                game_data: data
            })
        );
    },
    authToken: (token) => setItem(AUTH_TOKEN_KEY, token),
    gameplayId: (id) => setItem(GAMEPLAY_ID, id),
    gameId: (id) => setItem(GAME_KEY, id),
    levelData: (data) => setItem(LEVEL_DATA_KEY, data),
    gameDetails: (data) => setItem(GAME_DETAILS_KEY, data)
};

const get = {
    userData: () => {
        const data = localStorage.getItem(LS_KEY.user_data);
        if (data) {
            try {
                const decoded = JSON.parse(data);
                return decoded.user_data;
            } catch (err) {
                console.log(err);
            }
        }
    },
    gameData: () => {
        const data = localStorage.getItem(LS_KEY.game_data);
        if (data) {
            try {
                const decoded = JSON.parse(data);
                return decoded.game_data;
            } catch (err) {
                console.log(err);
            }
        }
    },
    authToken: () => getItem(AUTH_TOKEN_KEY),
    gameplayId: () => getItem(GAMEPLAY_ID),
    gameId: () => getItem(GAME_KEY),
    levelData: () => getItem(LEVEL_DATA_KEY),
    gameDetails: () => getItem(GAME_DETAILS_KEY)
};

const destroy = {
    userData: () => {
        localStorage.removeItem(LS_KEY.user_data);
    },
    gameData: () => {
        localStorage.removeItem(LS_KEY.game_data)
    },
    all: () => localStorage.clear()
};

export const storage = {
    set,
    get,
    destroy,
};
